export default __webpack_public_path__ + "static/media/Ss.9624b911.wav";